import React, { useContext } from 'react';
import { Container } from '@mui/material';

import Login from '../Login';
import Subtitle from '../ui/Subtitle';
import { backendCheckToken } from '../../backend/backend';
import { tokenContext } from '../TokenProvider';

const AdminLoginPage = () => {

	const {token,setToken}=useContext(tokenContext);

	if (!token) {
		return <Login setToken={setToken} />
	} else {
		backendCheckToken(token).then(
			(ok) => {
				if (!ok)
				{
					setToken(false);
				}
			}
		);
	}

	return (
		<Container>
			<Subtitle text="Logged in successfully" />
		</Container>
	)
}

export default AdminLoginPage;